import { GameSymbol, ComboType } from './enums';

/**
 * Prüft ob die aktuelle Walzen-Konfiguration eine Kombination erfüllt.
 * Wird sowohl serverseitig (Validierung) als auch clientseitig (UI-Feedback) verwendet.
 */
export function validateCombo(reels: GameSymbol[], comboType: ComboType): boolean {
  const counts = new Map<GameSymbol, number>();
  for (const symbol of reels) {
    counts.set(symbol, (counts.get(symbol) || 0) + 1);
  }
  const values = Array.from(counts.values()).sort((a, b) => b - a);

  switch (comboType) {
    case ComboType.THREE_CLOVERS:
      return (counts.get(GameSymbol.CLOVER) || 0) >= 3;

    case ComboType.THREE_MOONS:
      return (counts.get(GameSymbol.MOON) || 0) >= 3;

    case ComboType.THREE_HEARTS:
      return (counts.get(GameSymbol.HEART) || 0) >= 3;

    case ComboType.THREE_STARS:
      return (counts.get(GameSymbol.STAR) || 0) >= 3;

    case ComboType.THREE_CROWNS:
      return (counts.get(GameSymbol.CROWN) || 0) >= 3;

    case ComboType.THREE_HORSESHOES:
      return (counts.get(GameSymbol.HORSESHOE) || 0) >= 3;

    case ComboType.ONE_PAIR:
      return values[0] >= 2;

    case ComboType.JOKER:
      return true;

    case ComboType.FULL_HOUSE:
      return values.length >= 2 && values[0] >= 3 && values[1] >= 2;

    case ComboType.FIVE_DIFFERENT:
      return counts.size >= 5;

    case ComboType.FOUR_OF_A_KIND:
      return values[0] >= 4;

    case ComboType.FIVE_OF_A_KIND:
      return values[0] >= 5;

    default:
      return false;
  }
}
